import { Button, Container, Typography, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import LeftArrow from "../../assets/icons-svg/left-arrow.svg";
import LeftArrowBlue from "../../assets/icons-svg/left-arrow-blue.svg";
import SwipeableDrawerSection from "../common/SwipeableDrawerSection";
import AppToolbar from "../common/AppToolbar";
import { UserLayout } from "../user-details/models/user-interface";
import AppHeader from "../common/AppHeader";
import { AppContext } from "../routing/Routing";
import { PAGE_TITLES, VIEWS } from "../constants/user-info.const";
import { useLocation, useNavigate } from "react-router-dom";
import store from "../../store";
import { SET_IS_NAV_FROM_MENU } from "../../store/actions/navigationFromMenu";

export default function UserInfo(props: UserLayout) {
  const { title, children, hidePrevSection, hideNext, formRef } = props;
  const { viewName, setViewName } = useContext(AppContext);
  const location = useLocation();
  const smDevice = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const currentRoute = location.pathname;
  const [prevSection, setPreviousSection] = useState("");
  const [pageHeader, setPageHeader] = useState("");
  const routerArray = [
    "/personal-info",
    "/home-address",
    "/federal-taxes",
    "/state-taxes",
    "/payment-method",
    "/review-info",
    "/terms-of-service",
    "/e-sign",
  ];
  const sectionsMapping = {
    "/personal-info": "Personal Info",
    "/home-address": "Home Address",
    "/federal-taxes": "Federal Taxes",
    "/state-taxes": "State Taxes",
    "/payment-method": "Payment Method",
    "/review-info": "Review Info",
    "/terms-of-service": "Terms of Service",
    "/e-sign": "E-Sign",
  };
  useEffect(() => {
    const prevRoute = getPreviousRoute();
    if (!prevRoute) {
      return;
    }
    const prevSection = sectionsMapping[prevRoute];
    setPreviousSection(prevSection);
  }, [currentRoute]);
  useEffect(() => {
    const currentRoute = sectionsMapping[location.pathname];
    if (!currentRoute) return;
    setPageHeader(currentRoute);
  }, [currentRoute]);
  const getPreviousRoute = (): string => {
    const prevSection = routerArray[routerArray.indexOf(currentRoute) - 1];
    return prevSection || "";
  };
  const navigateToPrevRoute = () => {
    const prevRoute = getPreviousRoute();
    if (prevRoute) {
      navigate(prevRoute);
    }
  };
  const mobileHeader = () => {
    return (
      <div className="user-details__formHeaderMobile">
        <div className="user-details__formHeaderMobile--back">
          <img
            src={LeftArrow}
            alt={"Back Icon"}
            onClick={() => setViewName(VIEWS.toolbar)}
          />
        </div>

        <Typography variant="h6">{pageHeader}</Typography>
        <div className="user-details__formHeaderMobile--swipeIcon">
          <SwipeableDrawerSection swipeSection="top" />
        </div>
      </div>
    );
  };

  const previousSection = () => {
    return (
      <div className="user-details__prevSection">
        <div className="user-details__prevSection--icon">
          <img
            src={LeftArrowBlue}
            alt={"Back Icon"}
            onClick={() => navigateToPrevRoute()}
          />
        </div>
        <div>
          <a href="#" className="primary-link">
            Previous Section
          </a>
          <div className="user-details__prevSection--name">{prevSection}</div>
        </div>
      </div>
    );
  };
  const pageTitle = () => {
    return (
      <Typography className="user-details__formHeaderDesktop" variant="h5">
        {title}
      </Typography>
    );
  };
  const getRouteIndex = (): number => {
    const routerArray = [
      "/personal-info",
      "/home-address",
      "/federal-taxes",
      "/state-taxes",
      "/payment-method",
      "/review-info",
      "/terms-of-service",
      "e-sign",
    ];
    const currentLocation = location.pathname;
    if (routerArray.indexOf(currentLocation) > -1)
      return routerArray.indexOf(currentLocation) + 1;
    return 0;
  };
  const dispatchIsNavToStore = (isNav: boolean) => {
    store.dispatch({
      type: SET_IS_NAV_FROM_MENU,
      state: isNav,
    });
  };
  useEffect(() =>{
    dispatchIsNavToStore(true);
  },[])
  const pageFooter = () => {
    return (
      <div className="user-details__formFooterMobile">
        <Button
          variant="contained"
          className="btn-primary user-details__formFooterMobile--back"
          type="submit"
        >
          Back
        </Button>
        <div className="user-details__formFooterMobile--swipe">
          <SwipeableDrawerSection swipeSection="bottom" />
          <span>{getRouteIndex()} of 8</span>
        </div>

        {!hideNext && (
          <Button
            variant="contained"
            className="btn-primary user-details__formFooterMobile--next"
            type="submit"
            onClick={() => {
              dispatchIsNavToStore(true);
              props.handleSubmit?.();
            }}
            id="emp-next"
          >
            Next
          </Button>
        )}
      </div>
    );
  };
  const UserDetails = () => {
    return (
      <div className="user-details">
        {mobileHeader()}
        {!hidePrevSection && previousSection()}
        {pageTitle()}
        {children}
        {pageFooter()}
      </div>
    );
  };
  const showHideUserDetails = () => {
    const viewArray = [
      "personal-info",
      "home-address",
      "federal-taxes",
      "state-taxes",
      "payment-method",
      "review-info",
      "terms-of-service",
      "e-sign",
    ];
    if (!smDevice) {
      return UserDetails();
    }
    if (viewArray.includes(viewName)) {
      return UserDetails();
    }
  };
  return (
    <>
      <Container maxWidth={false}>
        <AppHeader />
        <div className="content">
          <AppToolbar formRef={formRef} />
          {showHideUserDetails()}
        </div>
      </Container>
    </>
  );
}
